function toggleSpinner() {
    const spinner = document.getElementById("loading-spinner");
    spinner.classList.toggle("hidden");
}

document.addEventListener("DOMContentLoaded", function () {
    const progressBar = document.getElementById("progress-bar");

    if (!progressBar) return; // No hay barra de progreso en la página

    // Inicia con un progreso inicial (por ejemplo, cargando recursos básicos)
    progressBar.style.width = "50%";

    // Completa la barra al cargar todos los recursos
    window.addEventListener("load", () => {
        progressBar.style.width = "100%"; // Llena completamente la barra
        setTimeout(() => {
            progressBar.style.opacity = "0"; // Oculta suavemente la barra
            setTimeout(() => {
                progressBar.style.display = "none"; // Elimina completamente la barra
            }, 300); // Tiempo para ocultar después de completar
        }, 500); // Tiempo para mostrarla llena antes de ocultarla
    });
});

// Toggle para bara de progreso en una función separada
function toggleProgressBar() {
    const progressBar = document.getElementById("progress-bar");
    if (progressBar) {

        // Hay que mostrar la barra de progreso de forma analoga a cómo se hace arriba
        if (progressBar.style.display === "none" ) {
            progressBar.style.display = "block"; // Asegura que se muestre
            progressBar.style.width = "100%"; // Muestra la barra de progreso
            progressBar.style.opacity = "1"; // Asegura que sea visible;
        } else {
            progressBar.style.width = "0%"; // Oculta la barra de progreso
            progressBar.style.opacity = "0"; // Oculta suavemente la barra
            setTimeout(() => {
                progressBar.style.display = "none"; // Elimina completamente la barra
            }, 300); // Tiempo para ocultar después de completar
        }
    }
}

